import { useContext } from 'react';
import { DzApiClientContext } from './dz-api-client-context';
export const useApiClient = () => {
    const apiClient = useContext(DzApiClientContext);
    return apiClient;
};
